import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'
import { MemberTableUI } from './MemberTableUI'

//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class MemberTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetMember?offset=";
    this.className = "Member";
    this.state.mode = "table";
  }

  render() {
    if (!this.state.isLoaded) {
      return <div className="box-body"> در حال بارگذاری</div>;
    }

    return (
      <div className="container">

        <MemberTableUI data={this.state.data}  />
        <Pagination pageNumber={this.state.pageNumber} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/tables/member/MemberTable.js